(()=>{"use strict";console.log("Im on contact!!!")})();
// "use strict";(self.webpackChunklumex_shopify_theme=self.webpackChunklumex_shopify_theme||[]).push([[706],{470:()=>{console.log("Im on contact!!!")}},e=>{var s;s=470,e(e.s=s)}]);